import {
    WHATSAPP_CREATE,
    WHATSAPP_LIST,
    WHATSAPP_UPDATE
} from "../actions";

export function whatsApp(currentState = {}, action) {
    switch (action.type) {
        case WHATSAPP_CREATE:
            return {
                type: action.type,
                list: currentState.list ? currentState.list.concat(action.list) : [action.list]
            }
        case WHATSAPP_LIST:
            return currentState = action
        case WHATSAPP_UPDATE:
            return {
                type: action.type,
                list:  currentState.list.map(current => current.id  === action.list.id ? action.list : current)
            }
        default:
            return currentState
    }
}